import { Component, OnInit } from '@angular/core';
import { UscStoreService } from '../../../services/usc-store/usc-store.service';
import { AuthService, CalendarService, DialogService } from '../../../services';
import { User } from '../../../models';
import { Subscription } from 'rxjs';
import { SliderComponent } from '../../common/slider/slider.component';
import { DialogComponent } from '../../common/dialog/dialog.component';

@Component({
    selector: 'sn-usc-sales-tracker',
    templateUrl: './usc-sales-tracker.component.html',
    styleUrls: ['./usc-sales-tracker.component.css']
})
export class UscSalesTrackerComponent implements OnInit {

    public action_plan: any;
    public days_remaining: number;
    public full_name:string;
    public todays_date:string;
    public sales_achievements:any;
    public active_user:User;
    public is_action_plan_loaded: boolean = false;
    portalReadySub:Subscription;

    public selected_month: string;
    public is_current_month: boolean = true;
    public available_months:Array<any> = [];
    public max_num_months: number = 12;
    public isPreviousMonthEnabled: boolean = false;
    public isUSCellAgent: boolean = false;
    public is_action_plan_submitted: boolean = false;

    public testing:any = { associate_ID:"0" };

    constructor(
        public uscStoreService: UscStoreService,
        public authService: AuthService,
        public calendarService: CalendarService,
        public dialogService: DialogService,
    ) {
        this.active_user = this.authService.getActive();
        this.testing.associate_ID = this.active_user.username;
        this.selected_month = this.uscStoreService.getThisMonthActionPlanSubject();

        this.portalReadySub = this.uscStoreService.portalReady.subscribe(ready => {
            // only reload current view this.action_plan is loaded
            if (ready && this.is_action_plan_loaded) this.uscStoreService.setCurrentView(this.uscStoreService.view_p2w_sales_tracker);
        });

        this.uscStoreService.getThisMonthActionPlans().subscribe(
            result => {
                this.action_plan = result;
                this.days_remaining = 0;
                if (this.action_plan) this.days_remaining = this.action_plan.cs_days_scheduled - this.action_plan.days_worked + 1;
                this.is_action_plan_submitted = this.uscStoreService.isActionPlanSubmitted(this.action_plan);
                this.is_action_plan_loaded = true;
            }
        )
    }

    ngOnInit() {
        this.isUSCellAgent = this.uscStoreService.isUSCellAgent();
        this.isPreviousMonthEnabled = !this.uscStoreService.isUSCellAgent();
        if (this.isPreviousMonthEnabled) {
            this.available_months = this.uscStoreService.getAvailableActionPlanMonths(current_user);
        }
        this.full_name = this.active_user.first_name + ' ' + this.active_user.last_name;
        this.is_current_month = this.selected_month == this.uscStoreService.getThisMonthActionPlanSubject();
        var current_user = this.authService.getActive();
    }

    onFocusOut(field) {
        switch (field) {
            case "associate_ID": this.uscStoreService.setP2wSalesTrackerTesting(this.testing); break;
        }
    }

    ngOnDestroy() {
        if (this.portalReadySub) this.portalReadySub.unsubscribe();
    }

    getMonthDisplayValue(month) { return this.uscStoreService.convertPlanMonth(month); }
    public updateMonthlyDashboard(month) { 
        this.selected_month = month; 
        this.is_current_month = this.selected_month == this.uscStoreService.getThisMonthActionPlanSubject();

        if (this.is_current_month) {
            this.uscStoreService.setP2WScopeMonth(this.selected_month);
        } else {
            var dlg = this.dialogService.showLoadingDlg(DialogComponent, {msg: "Loading selected monthly data..."});
            this.uscStoreService.loadActionPlansByMonth(month).subscribe(plans => {
                dlg.dismiss();
                this.uscStoreService.setP2WScopeMonth(this.selected_month);
            })
        }
    } 
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store/usc-sales-tracker/usc-sales-tracker.component.ts